const STEP_TUTORIAL = {
  INIT: "init",
  CLICK_PLACE: "click_place",
  SELECT_BUILDING: "select_building",
  COLLECT_RESOURCES: "collect_resources",
  OPEN_SELL: "open_sell",
  SELL: "sell",
} as const;
type StepTutorialTypes = (typeof STEP_TUTORIAL)[keyof typeof STEP_TUTORIAL];

export { STEP_TUTORIAL, type StepTutorialTypes };
